/**
 * G-85 S5 — the calendar day a `Date` falls on, as `YYYY-MM-DD`.
 *
 * ═══════════════════════════════════════════════════════════════════════════
 * THIS IS A KEY, NOT A DATE ON SCREEN. It must never follow the UI language.
 * ═══════════════════════════════════════════════════════════════════════════
 *
 * It is what an order, a shift and a task are grouped by, what a `<input
 * type="date">` reads and writes, and what goes to the server. A Russian
 * florist and a Catalan one must produce the same string for the same day, or
 * today's orders stop matching today. S5 makes dates on SCREEN follow the
 * language; this is the line on the other side of that change, which is why
 * it lives in one file with a test rather than inline at five call sites.
 *
 * WHY NOT `toLocaleDateString("sv-SE")`, which three of those call sites used:
 * it works by picking a locale whose format happens to be ISO-like, so it is
 * correct by coincidence. A runtime without Swedish data falls back to the
 * default locale and quietly returns `9/21/2026`, and the failure is a
 * mismatch in date grouping rather than an error anyone would see. Building
 * the string from the parts cannot do that.
 *
 * LOCAL parts, deliberately — not `toISOString`, which converts to UTC and so
 * reports the wrong day for anyone east of Greenwich in the evening. Barcelona
 * is UTC+1/+2: at 23:30 on the 21st, `toISOString()` says the 22nd.
 */
export function localDayKey(d: Date): string {
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}
